export const AUTH_CONFIG = {
    domain: import.meta.env.VITE_APP_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_APP_AUTH0_CLIENT_ID,
    redirectUri: new URL(import.meta.env.BASE_URL, window.origin).href,
    afterLogout: import.meta.url,
    audience: import.meta.env.VITE_APP_AUTH0_AUDIENCE,
    scope: import.meta.env.VITE_APP_AUTH0_SCOPE,
};
